
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useLottie } from 'lottie-react';

import loadingAnimationSavingRecipe from '../../lottie/loadingAnimationSavingRecipe.json';
import styles from "./loadingUpAnimationGeneratingMealPlan.module.css";

const LoadingUpAnimationGeneratingMealPlan = () => {
    const options = {
        animationData: loadingAnimationSavingRecipe,
        loop: true,
    };
    const { View } = useLottie(options);
    const text = 'Generating your meal plan. This might take a few minutes.';

    return (
        <Grid className={styles.up_animation_save_recipe_main_grid}   >
            {View}
            <Grid className={styles.up_animation_save_recipe_text_layer}>
                <Typography variant='caption3Light' className={styles.up_animation_save_recipe_text}>
                    {text}
                </Typography>
            </Grid>
        </Grid>
    );
}

export default LoadingUpAnimationGeneratingMealPlan;
